



















import { Component, Prop, Vue } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import { INotificationArrowProps } from './NotificationArrow';
import eventBus from '@/utils/eventBus';
import { sleep } from '@/utils';

const WIDTH_COMPONENT = 278;

@Component({
  components: {
    FilledButton
  }
})
export default class NotificationArrow extends Vue {
  @Prop() notificationArrowProps!: INotificationArrowProps;

  closed = false;

  timeout: any = null;

  get offset() {
    if (!this.notificationArrowProps.element) return { left: 0, top: 0 };
    return this.getOffset(this.notificationArrowProps.element);
  }

  get direction() {
    return this.notificationArrowProps.arrowDirection || 'right';
  }

  getOffset(el: HTMLElement) {
    const rect = el.getBoundingClientRect();

    let left = rect.left + window.scrollX - WIDTH_COMPONENT + rect.width;

    if (this.direction === 'center')
      left = rect.left + window.scrollX - WIDTH_COMPONENT / 2 + rect.width / 2;

    if (this.direction === 'left') left = rect.left + window.scrollX;

    return {
      left,
      top: rect.top + window.scrollY + rect.height + 4
    };
  }

  async close() {
    clearTimeout(this.timeout);
    this.closed = true;

    await sleep(1000);
    eventBus.$emit('closeNotificationArrow');
  }

  created() {
    this.timeout = setTimeout(() => {
      this.close();
    }, 8000);
  }
}
